import ActionHint from '../ActionHint';
import { EXCLUDE_HELPER, EXCLUDE_LABEL } from '../constants';
import { ExcludeCopy, ExcludeHelper, ExcludeLabel, ExcludeRoot } from './styled';
import type { ExcludeToggleProps } from './types';

const ExcludeToggle = ({ excluded, disabled = false, disabledReason = null, onChange }: ExcludeToggleProps) => (
  <ActionHint title={disabled ? disabledReason : null} testId="idv-exclude-hint" blocked={disabled}>
    <ExcludeRoot data-testid="idv-exclude-toggle" disabled={disabled}>
      <input
        type="checkbox"
        checked={excluded}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <ExcludeCopy>
        <ExcludeLabel>{EXCLUDE_LABEL}</ExcludeLabel>
        <ExcludeHelper>{EXCLUDE_HELPER}</ExcludeHelper>
      </ExcludeCopy>
    </ExcludeRoot>
  </ActionHint>
);

export default ExcludeToggle;
